import PageShare from '@/share/pages/page-share'
import PageViewMap from '@/public/pages/page-view-map'
import PageChoosePeople from '@/public/pages/page-choose-people'
import PageChooseSelected from '@/public/pages/page-choose-selected'

export default {
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: PageShare,
      meta: {
        title: '分享',

        // useSdk: true,
      },
    },
    {
      path: '/map/:lon/:lat/:address',
      component: PageViewMap,
      meta: {
        title: '发起位置',

        // useSdk: true,
      },
    },
    {
      path: '/page-empty',
      meta: { title: '出错啦' },
      name: 'empty',
      component: () => import('@/public/pages/page-empty'),
    },
    {
      path: '/choosePeople',
      meta: {
        title: '抄送人',

        // useSdk: true,

        // keepAlive: true,
      },
      component: PageChoosePeople,
    },
    {
      path: '/chooseSelected',
      meta: {
        title: '抄送人',

        // useSdk: true,
      },
      component: PageChooseSelected,
    },
  ],
}
